/* =======================
 // Common Admission ------------- configs
   ======================= */
export const GENDER_OPTIONS = [
  { label: "Female", value: "female" },
  { label: "Male", value: "male" },
  { label: "Other", value: "other" },
];
export const COUNTRY_OPTIONS = [
  { label: "Afghanistan", value: "afghanistan" },
  { label: "Albania", value: "albania" },
  { label: "Algeria", value: "algeria" },
  { label: "Andorra", value: "andorra" },
  { label: "Angola", value: "angola" },
  { label: "Antigua and Barbuda", value: "antigua_and_barbuda" },
  { label: "Argentina", value: "argentina" },
  { label: "Armenia", value: "armenia" },
  { label: "Australia", value: "australia" },
  { label: "Austria", value: "austria" },
  { label: "Azerbaijan", value: "azerbaijan" },
  { label: "Bahamas", value: "bahamas" },
  { label: "Bahrain", value: "bahrain" },
  { label: "Bangladesh", value: "bangladesh" },
  { label: "Barbados", value: "barbados" },
  { label: "Belarus", value: "belarus" },
  { label: "Belgium", value: "belgium" },
  { label: "Belize", value: "belize" },
  { label: "Benin", value: "benin" },
  { label: "Bhutan", value: "bhutan" },
  { label: "Bolivia", value: "bolivia" },
  { label: "Bosnia and Herzegovina", value: "bosnia_and_herzegovina" },
  { label: "Botswana", value: "botswana" },
  { label: "Brazil", value: "brazil" },
  { label: "Brunei", value: "brunei" },
  { label: "Bulgaria", value: "bulgaria" },
  { label: "Burkina Faso", value: "burkina_faso" },
  { label: "Burundi", value: "burundi" },
  { label: "Cabo Verde", value: "cabo_verde" },
  { label: "Cambodia", value: "cambodia" },
  { label: "Cameroon", value: "cameroon" },
  { label: "Canada", value: "canada" },
  { label: "Central African Republic", value: "central_african_republic" },
  { label: "Chad", value: "chad" },
  { label: "Chile", value: "chile" },
  { label: "China", value: "china" },
  { label: "Colombia", value: "colombia" },
  { label: "Comoros", value: "comoros" },
  { label: "Congo (Congo-Brazzaville)", value: "congo_brazzaville" },
  { label: "Congo (Congo-Kinshasa)", value: "congo_kinshasa" },
  { label: "Costa Rica", value: "costa_rica" },
  { label: "Croatia", value: "croatia" },
  { label: "Cuba", value: "cuba" },
  { label: "Cyprus", value: "cyprus" },
  { label: "Czechia (Czech Republic)", value: "czechia" },
  { label: "Denmark", value: "denmark" },
  { label: "Djibouti", value: "djibouti" },
  { label: "Dominica", value: "dominica" },
  { label: "Dominican Republic", value: "dominican_republic" },
  { label: "Ecuador", value: "ecuador" },
  { label: "Egypt", value: "egypt" },
  { label: "El Salvador", value: "el_salvador" },
  { label: "Equatorial Guinea", value: "equatorial_guinea" },
  { label: "Eritrea", value: "eritrea" },
  { label: "Estonia", value: "estonia" },
  { label: "Eswatini", value: "eswatini" },
  { label: "Ethiopia", value: "ethiopia" },
  { label: "Fiji", value: "fiji" },
  { label: "Finland", value: "finland" },
  { label: "France", value: "france" },
  { label: "Gabon", value: "gabon" },
  { label: "Gambia", value: "gambia" },
  { label: "Georgia", value: "georgia" },
  { label: "Germany", value: "germany" },
  { label: "Ghana", value: "ghana" },
  { label: "Greece", value: "greece" },
  { label: "Grenada", value: "grenada" },
  { label: "Guatemala", value: "guatemala" },
  { label: "Guinea", value: "guinea" },
  { label: "Guinea-Bissau", value: "guinea_bissau" },
  { label: "Guyana", value: "guyana" },
  { label: "Haiti", value: "haiti" },
  { label: "Honduras", value: "honduras" },
  { label: "Hungary", value: "hungary" },
  { label: "Iceland", value: "iceland" },
  { label: "India", value: "india" },
  { label: "Indonesia", value: "indonesia" },
  { label: "Iran", value: "iran" },
  { label: "Iraq", value: "iraq" },
  { label: "Ireland", value: "ireland" },
  { label: "Israel", value: "israel" },
  { label: "Italy", value: "italy" },
  { label: "Jamaica", value: "jamaica" },
  { label: "Japan", value: "japan" },
  { label: "Jordan", value: "jordan" },
  { label: "Kazakhstan", value: "kazakhstan" },
  { label: "Kenya", value: "kenya" },
  { label: "Kiribati", value: "kiribati" },
  { label: "Korea, North", value: "north_korea" },
  { label: "Korea, South", value: "south_korea" },
  { label: "Kuwait", value: "kuwait" },
  { label: "Kyrgyzstan", value: "kyrgyzstan" },
  { label: "Laos", value: "laos" },
  { label: "Latvia", value: "latvia" },
  { label: "Lebanon", value: "lebanon" },
  { label: "Lesotho", value: "lesotho" },
  { label: "Liberia", value: "liberia" },
  { label: "Libya", value: "libya" },
  { label: "Liechtenstein", value: "liechtenstein" },
  { label: "Lithuania", value: "lithuania" },
  { label: "Luxembourg", value: "luxembourg" },
  { label: "Madagascar", value: "madagascar" },
  { label: "Malawi", value: "malawi" },
  { label: "Malaysia", value: "malaysia" },
  { label: "Maldives", value: "maldives" },
  { label: "Mali", value: "mali" },
  { label: "Malta", value: "malta" },
  { label: "Marshall Islands", value: "marshall_islands" },
  { label: "Mauritania", value: "mauritania" },
  { label: "Mauritius", value: "mauritius" },
  { label: "Mexico", value: "mexico" },
  { label: "Micronesia", value: "micronesia" },
  { label: "Moldova", value: "moldova" },
  { label: "Monaco", value: "monaco" },
  { label: "Mongolia", value: "mongolia" },
  { label: "Montenegro", value: "montenegro" },
  { label: "Morocco", value: "morocco" },
  { label: "Mozambique", value: "mozambique" },
  { label: "Myanmar", value: "myanmar" },
  { label: "Namibia", value: "namibia" },
  { label: "Nauru", value: "nauru" },
  { label: "Nepal", value: "nepal" },
  { label: "Netherlands", value: "netherlands" },
  { label: "New Zealand", value: "new_zealand" },
  { label: "Nicaragua", value: "nicaragua" },
  { label: "Niger", value: "niger" },
  { label: "Nigeria", value: "nigeria" },
  { label: "North Macedonia", value: "north_macedonia" },
  { label: "Norway", value: "norway" },
  { label: "Oman", value: "oman" },
  { label: "Pakistan", value: "pakistan" },
  { label: "Palau", value: "palau" },
  { label: "Panama", value: "panama" },
  { label: "Papua New Guinea", value: "papua_new_guinea" },
  { label: "Paraguay", value: "paraguay" },
  { label: "Peru", value: "peru" },
  { label: "Philippines", value: "philippines" },
  { label: "Poland", value: "poland" },
  { label: "Portugal", value: "portugal" },
  { label: "Qatar", value: "qatar" },
  { label: "Romania", value: "romania" },
  { label: "Russia", value: "russia" },
  { label: "Rwanda", value: "rwanda" },
  { label: "Saint Kitts and Nevis", value: "saint_kitts_and_nevis" },
  { label: "Saint Lucia", value: "saint_lucia" },
  {
    label: "Saint Vincent and the Grenadines",
    value: "saint_vincent_and_the_grenadines",
  },
  { label: "Samoa", value: "samoa" },
  { label: "San Marino", value: "san_marino" },
  { label: "Sao Tome and Principe", value: "sao_tome_and_principe" },
  { label: "Saudi Arabia", value: "saudi_arabia" },
  { label: "Senegal", value: "senegal" },
  { label: "Serbia", value: "serbia" },
  { label: "Seychelles", value: "seychelles" },
  { label: "Sierra Leone", value: "sierra_leone" },
  { label: "Singapore", value: "singapore" },
  { label: "Slovakia", value: "slovakia" },
  { label: "Slovenia", value: "slovenia" },
  { label: "Solomon Islands", value: "solomon_islands" },
  { label: "Somalia", value: "somalia" },
  { label: "South Africa", value: "south_africa" },
  { label: "South Korea", value: "south_korea" },
  { label: "South Sudan", value: "south_sudan" },
  { label: "Spain", value: "spain" },
  { label: "Sri Lanka", value: "sri_lanka" },
  { label: "Sudan", value: "sudan" },
  { label: "Suriname", value: "suriname" },
  { label: "Sweden", value: "sweden" },
  { label: "Switzerland", value: "switzerland" },
  { label: "Syria", value: "syria" },
  { label: "Taiwan", value: "taiwan" },
  { label: "Tajikistan", value: "tajikistan" },
  { label: "Tanzania", value: "tanzania" },
  { label: "Thailand", value: "thailand" },
  { label: "Timor-Leste", value: "timor_leste" },
  { label: "Togo", value: "togo" },
  { label: "Tonga", value: "tonga" },
  { label: "Trinidad and Tobago", value: "trinidad_and_tobago" },
  { label: "Tunisia", value: "tunisia" },
  { label: "Turkey", value: "turkey" },
  { label: "Turkmenistan", value: "turkmenistan" },
  { label: "Tuvalu", value: "tuvalu" },
  { label: "Uganda", value: "uganda" },
  { label: "Ukraine", value: "ukraine" },
  { label: "United Arab Emirates", value: "uae" },
  { label: "United Kingdom", value: "united_kingdom" },
  { label: "United States", value: "united_states" },
  { label: "Uruguay", value: "uruguay" },
  { label: "Uzbekistan", value: "uzbekistan" },
  { label: "Vanuatu", value: "vanuatu" },
  { label: "Vatican City", value: "vatican_city" },
  { label: "Venezuela", value: "venezuela" },
  { label: "Vietnam", value: "vietnam" },
  { label: "Yemen", value: "yemen" },
  { label: "Zambia", value: "zambia" },
  { label: "Zimbabwe", value: "zimbabwe" },
];

export const RELIGION_OPTIONS = [
  { label: "Islam", value: "islam" },
  { label: "Christianity", value: "christianity" },
  { label: "Hinduism", value: "hinduism" },
  { label: "Buddhism", value: "buddhism" },
  { label: "Judaism", value: "judaism" },
  { label: "Sikhism", value: "sikhism" },
  { label: "Bahá'í", value: "bahai" },
  { label: "Jainism", value: "jainism" },
  { label: "Shinto", value: "shinto" },
  { label: "Taoism", value: "taoism" },
  { label: "Zoroastrianism", value: "zoroastrianism" },
  { label: "Confucianism", value: "confucianism" },
  { label: "Agnosticism", value: "agnosticism" },
  { label: "Atheism", value: "atheism" },
  { label: "Paganism", value: "paganism" },
  { label: "Cao Dai", value: "cao_dai" },
  { label: "Tenrikyo", value: "tenrikyo" },
  { label: "Rastafarianism", value: "rastafarianism" },
  { label: "Spiritism", value: "spiritism" },
];
export const CONTACT_TYPE_OPTIONS = [
  { value: "father", label: "Father" },
  { value: "mother", label: "Mother" },
  { value: "guardian", label: "Guardian" },
];
export const NATIVE_LANGUAGE_OPTIONS = [
  { label: "Abkhaz", value: "ab" },
  { label: "Afar", value: "aa" },
  { label: "Afrikaans", value: "af" },
  { label: "Akan", value: "ak" },
  { label: "Albanian", value: "sq" },
  { label: "Amharic", value: "am" },
  { label: "Arabic", value: "ar" },
  { label: "Aragonese", value: "an" },
  { label: "Armenian", value: "hy" },
  { label: "Assamese", value: "as" },
  { label: "Atsam", value: "cch" },
  { label: "Avaric", value: "av" },
  { label: "Aymara", value: "ay" },
  { label: "Azerbaijani", value: "az" },

  { label: "Bambara", value: "bm" },
  { label: "Bashkir", value: "ba" },
  { label: "Basque", value: "eu" },
  { label: "Belarusian", value: "be" },
  { label: "Bemba", value: "bem" },
  { label: "Bengali", value: "bn" },
  { label: "Bhojpuri", value: "bho" },
  { label: "Bislama", value: "bi" },
  { label: "Bosnian", value: "bs" },
  { label: "Breton", value: "br" },
  { label: "Buginese", value: "bug" },
  { label: "Bulgarian", value: "bg" },
  { label: "Burmese", value: "my" },

  { label: "Catalan", value: "ca" },
  { label: "Cebuano", value: "ceb" },
  { label: "Central Atlas Tamazight", value: "tzm" },
  { label: "Chamorro", value: "ch" },
  { label: "Chechen", value: "ce" },
  { label: "Cherokee", value: "chr" },
  { label: "Chinese", value: "zh" },
  { label: "Chichewa", value: "ny" },
  { label: "Chiga", value: "cgg" },
  { label: "Chuvash", value: "cv" },
  { label: "Cornish", value: "kw" },
  { label: "Corsican", value: "co" },
  { label: "Cree", value: "cr" },
  { label: "Croatian", value: "hr" },
  { label: "Czech", value: "cs" },

  { label: "Danish", value: "da" },
  { label: "Divehi", value: "dv" },
  { label: "Dogri", value: "doi" },
  { label: "Duala", value: "dua" },
  { label: "Dutch", value: "nl" },
  { label: "Dzongkha", value: "dz" },

  { label: "English", value: "en" },
  { label: "Esperanto", value: "eo" },
  { label: "Estonian", value: "et" },
  { label: "Ewe", value: "ee" },
  { label: "Ewe‑Gbe", value: "ewe-gbe" },

  { label: "Faroese", value: "fo" },
  { label: "Fijian", value: "fj" },
  { label: "Filipino", value: "fil" },
  { label: "Finnish", value: "fi" },
  { label: "French", value: "fr" },
  { label: "Fulah", value: "ff" },
  { label: "Fur", value: "fur" },

  { label: "Galician", value: "gl" },
  { label: "Ganda", value: "lg" },
  { label: "Georgian", value: "ka" },
  { label: "German", value: "de" },
  { label: "Gikuyu", value: "ki" },
  { label: "Gilbertese", value: "gil" },
  { label: "Greek", value: "el" },
  { label: "Greenlandic (Kalaallisut)", value: "kl" },
  { label: "Guarani", value: "gn" },
  { label: "Gujarati", value: "gu" },
  { label: "Gusii", value: "guz" },

  { label: "Haitian Creole", value: "ht" },
  { label: "Hausa", value: "ha" },
  { label: "Hawaiian", value: "haw" },
  { label: "Hebrew", value: "he" },
  { label: "Herero", value: "hz" },
  { label: "Hindi", value: "hi" },
  { label: "Hiri Motu", value: "ho" },
  { label: "Hmong", value: "hmn" },
  { label: "Hungarian", value: "hu" },
  { label: "Hupa", value: "hup" },

  { label: "Iban", value: "iba" },
  { label: "Icelandic", value: "is" },
  { label: "Ido", value: "io" },
  { label: "Igbo", value: "ig" },
  { label: "Iloko", value: "ilo" },
  { label: "Indonesian", value: "id" },
  { label: "Ingush", value: "inh" },
  { label: "Innu‑aimun", value: "moe" },
  { label: "Interlingua", value: "ia" },
  { label: "Interlingue", value: "ie" },
  { label: "Inuktitut", value: "iu" },
  { label: "Inupiaq", value: "ik" },
  { label: "Irish", value: "ga" },
  { label: "Italian", value: "it" },
  { label: "Ivrit (Modern Hebrew)", value: "he-IL" },

  { label: "Japanese", value: "ja" },
  { label: "Javanese", value: "jv" },
  { label: "Jju", value: "kaj" },
  { label: "Jola‑Fonyi", value: "jol" },

  { label: "Kabardian", value: "kbd" },
  { label: "Kabyle", value: "kab" },
  { label: "Kalaallisut", value: "kl" },
  { label: "Kamba", value: "kam" },
  { label: "Kannada", value: "kn" },
  { label: "Kanuri", value: "kr" },
  { label: "Kashmiri", value: "ks" },
  { label: "Kazakh", value: "kk" },
  { label: "Khasi", value: "kha" },
  { label: "Khmer", value: "km" },
  { label: "Kikuyu", value: "ki" },
  { label: "Kinyarwanda", value: "rw" },
  { label: "Kirundi", value: "rn" },
  { label: "Komi", value: "kv" },
  { label: "Kongo", value: "kg" },
  { label: "Konkani", value: "kok" },
  { label: "Korean", value: "ko" },
  { label: "Kpelle", value: "kpe" },
  { label: "Kurdish", value: "ku" },
  { label: "Kurukh", value: "kru" },
  { label: "Kwanyama", value: "kj" },
  { label: "Kyrgyz", value: "ky" },

  { label: "Ladino", value: "lad" },
  { label: "Lao", value: "lo" },
  { label: "Latin", value: "la" },
  { label: "Latvian", value: "lv" },
  { label: "Lezghian", value: "lez" },
  { label: "Limburgish", value: "li" },
  { label: "Lingala", value: "ln" },
  { label: "Lithuanian", value: "lt" },
  { label: "Lojban", value: "jbo" },
  { label: "Luba‑Katanga", value: "lu" },
  { label: "Luba‑Lulua", value: "lua" },
  { label: "Lunda", value: "lun" },
  { label: "Luo", value: "luo" },
  { label: "Luxembourgish", value: "lb" },

  { label: "Macedonian", value: "mk" },
  { label: "Madurese", value: "mad" },
  { label: "Magahi", value: "mag" },
  { label: "Maithili", value: "mai" },
  { label: "Makhuwa", value: "vmw" },
  { label: "Malagasy", value: "mg" },
  { label: "Malay", value: "ms" },
  { label: "Malayalam", value: "ml" },
  { label: "Maltese", value: "mt" },
  { label: "Manchu", value: "mnc" },
  { label: "Mandar", value: "mdr" },
  { label: "Mandingo", value: "man" },
  { label: "Manx", value: "gv" },
  { label: "Maori", value: "mi" },
  { label: "Mapudungun", value: "arn" },
  { label: "Marathi", value: "mr" },
  { label: "Marshallese", value: "mh" },
  { label: "Meitei (Manipuri)", value: "mni" },
  { label: "Mende", value: "men" },
  { label: "Mizo", value: "lus" },
  { label: "Mongolian", value: "mn" },
  { label: "Mossi", value: "mos" },
  { label: "Mundari", value: "unr" },
  { label: "Māori (Cook Islands)", value: "rar" },
  { label: "Myanmar (Burmese)", value: "my" },

  { label: "Nauru", value: "na" },
  { label: "Navajo", value: "nv" },
  { label: "Ndonga", value: "ng" },
  { label: "Nepali", value: "ne" },
  { label: "Newari", value: "new" },
  { label: "Nigerian Pidgin", value: "pcm" },
  { label: "Niuean", value: "niu" },
  { label: "Northern Sotho", value: "nso" },
  { label: "Norwegian", value: "no" },
  { label: "Nyanja", value: "ny" },
  { label: "Nyankole", value: "nyn" },
  { label: "N’Ko", value: "nqo" },

  { label: "Occitan", value: "oc" },
  { label: "Odia (Oriya)", value: "or" },
  { label: "Ojibwe", value: "oj" },
  { label: "Oromo", value: "om" },
  { label: "Ossetian", value: "os" },

  { label: "Pali", value: "pi" },
  { label: "Pampangan", value: "pam" },
  { label: "Pangasinan", value: "pag" },
  { label: "Pashto", value: "ps" },
  { label: "Persian (Farsi)", value: "fa" },
  { label: "Polish", value: "pl" },
  { label: "Portuguese", value: "pt" },
  { label: "Punjabi", value: "pa" },

  { label: "Quechua", value: "qu" },
  { label: "Quechua (Cusco)", value: "quz" },

  { label: "Romanian", value: "ro" },
  { label: "Romansh", value: "rm" },
  { label: "Rundi (Kirundi)", value: "rn" },
  { label: "Russian", value: "ru" },
  { label: "Rwa", value: "rwk" },

  { label: "Samoan", value: "sm" },
  { label: "Sango", value: "sg" },
  { label: "Sanskrit", value: "sa" },
  { label: "Sardinian", value: "sc" },
  { label: "Scottish Gaelic", value: "gd" },
  { label: "Serbian", value: "sr" },
  { label: "Sesotho", value: "st" },
  { label: "Setswana", value: "tn" },
  { label: "Shona", value: "sn" },
  { label: "Sicilian", value: "scn" },
  { label: "Sidamo", value: "sid" },
  { label: "Sindhi", value: "sd" },
  { label: "Sinhala", value: "si" },
  { label: "Slovak", value: "sk" },
  { label: "Slovene", value: "sl" },
  { label: "Somali", value: "so" },
  { label: "Spanish", value: "es" },
  { label: "Sranan Tongo", value: "srn" },
  { label: "Sundanese", value: "su" },
  { label: "Swahili", value: "sw" },
  { label: "Swati", value: "ss" },
  { label: "Swedish", value: "sv" },
  { label: "Sylheti", value: "syl" },

  { label: "Tagalog", value: "tl" },
  { label: "Tajik", value: "tg" },
  { label: "Tamashek", value: "tmh" },
  { label: "Tamil", value: "ta" },
  { label: "Tatar", value: "tt" },
  { label: "Telugu", value: "te" },
  { label: "Tetum", value: "tet" },
  { label: "Thai", value: "th" },
  { label: "Tibetan", value: "bo" },
  { label: "Tigrinya", value: "ti" },
  { label: "Tiv", value: "tiv" },
  { label: "Tok Pisin", value: "tpi" },
  { label: "Tokelauan", value: "tkl" },
  { label: "Tonga", value: "to" },
  { label: "Tsonga", value: "ts" },
  { label: "Turkish", value: "tr" },
  { label: "Turkmen", value: "tk" },
  { label: "Tumbuka", value: "tum" },
  { label: "Tupi (Guarani)", value: "tup" },
  { label: "Tuvalu", value: "tvl" },
  { label: "Twi", value: "tw" },

  { label: "Udmurt", value: "udm" },
  { label: "Uighur", value: "ug" },
  { label: "Ukrainian", value: "uk" },
  { label: "Urdu", value: "ur" },
  { label: "Uzbek", value: "uz" },

  { label: "Venda", value: "ve" },
  { label: "Vietnamese", value: "vi" },
  { label: "Volapük", value: "vo" },
  { label: "Votic", value: "vot" },

  { label: "Walloon", value: "wa" },
  { label: "Waray", value: "war" },
  { label: "Welsh", value: "cy" },
  { label: "Wolaytta", value: "wal" },
  { label: "Wolof", value: "wo" },
  { label: "Wu Chinese", value: "wuu" },

  { label: "Xhosa", value: "xh" },
  { label: "Xiang Chinese", value: "hsn" },

  { label: "Yakut (Sakha)", value: "sah" },
  { label: "Yao", value: "yao" },
  { label: "Yiddish", value: "yi" },
  { label: "Yoruba", value: "yo" },
  { label: "Yucatec Maya", value: "yua" },

  { label: "Zarma", value: "dje" },
  { label: "Zaza", value: "zza" },
  { label: "Zhuang", value: "za" },
  { label: "Zulu", value: "zu" },
];

export const bloodGroupOptions = [
  { label: "A+", value: "A+" },
  { label: "A-", value: "A-" },
  { label: "B+", value: "B+" },
  { label: "B-", value: "B-" },
  { label: "AB+", value: "AB+" },
  { label: "AB-", value: "AB-" },
  { label: "O+", value: "O+" },
  { label: "O-", value: "O-" },
  { label: "Rh+", value: "Rh+" },
  { label: "Rh-", value: "Rh-" },
];
export const LANGUAGE_OPTIONS = [
  { label: "Acehnese", value: "acehnese" },
  { label: "Afrikaans", value: "afrikaans" },
  { label: "Akan (Twi)", value: "akan-twi" },
  { label: "Aleut", value: "aleut" },
  { label: "Amharic", value: "amharic" },
  { label: "Antillean Creole", value: "antillean-creole" },
  { label: "Apache (Western)", value: "apache-western" },
  { label: "Aragonese", value: "aragonese" },
  { label: "Arrernte", value: "arrernte" },
  { label: "Assamese", value: "assamese" },
  { label: "Avar", value: "avar" },
  { label: "Aymara", value: "aymara" },
  { label: "Aymara (Bolivian)", value: "aymara-bolivian" },
  { label: "Azerbaijani", value: "azerbaijani" },
  { label: "Balinese", value: "balinese" },
  { label: "Baluchi", value: "baluchi" },
  { label: "Bambara", value: "bambara" },
  { label: "Basque", value: "basque" },
  { label: "Bavarian", value: "bavarian" },
  { label: "Belarusian", value: "belarusian" },
  { label: "Belizean Kriol", value: "belizean-kriol" },
  { label: "Bemba", value: "bemba" },
  { label: "Bengali", value: "bengali" },
  { label: "Betawi", value: "betawi" },
  { label: "Bhojpuri", value: "bhojpuri" },
  { label: "Bikol", value: "bikol" },
  { label: "Bislama", value: "bislama" },
  { label: "Bubi", value: "bubi" },
  { label: "Buginese", value: "buginese" },
  { label: "Bulgarian", value: "bulgarian" },
  { label: "Burmese", value: "burmese" },
  { label: "Buryat", value: "buryat" },
  { label: "Cantonese (Yue Chinese)", value: "cantonese-yue-chinese" },
  { label: "Catalan", value: "catalan" },
  { label: "Cebuano", value: "cebuano" },
  { label: "Chechen", value: "chechen" },
  { label: "Cherokee", value: "cherokee" },
  { label: "Chhattisgarhi", value: "chhattisgarhi" },
  { label: "Chittagonian", value: "chittagonian" },
  { label: "Choctaw", value: "choctaw" },
  { label: "Chuvash", value: "chuvash" },
  { label: "Comanche", value: "comanche" },
  { label: "Corsican", value: "corsican" },
  { label: "Crow", value: "crow" },
  { label: "Czech", value: "czech" },
  { label: "Danish", value: "danish" },
  { label: "Dari", value: "dari" },
  { label: "Deccan (Hyderabadi Urdu)", value: "deccan-hyderabadi-urdu" },
  { label: "Dogri", value: "dogri" },
  { label: "Dutch", value: "dutch" },
  { label: "Dzongkha", value: "dzongkha" },
  { label: "English", value: "english" },
  { label: "Esperanto", value: "esperanto" },
  { label: "Estonian", value: "estonian" },
  { label: "Ewe", value: "ewe" },
  { label: "Fang", value: "fang" },
  { label: "Faroese", value: "faroese" },
  { label: "Fijian", value: "fijian" },
  { label: "Fijian Hindi", value: "fijian-hindi" },
  { label: "Finnish", value: "finnish" },
  { label: "French", value: "french" },
  { label: "Fula (Fulfulde, Pulaar)", value: "fula" },
  { label: "Ga", value: "ga" },
  { label: "Galician", value: "galician" },
  { label: "Gan Chinese", value: "gan-chinese" },
  { label: "Garhwali‑Kumaoni", value: "garhwali-kumaoni" },
  { label: "Garifuna", value: "garifuna" },
  { label: "Garo", value: "garo" },
  { label: "German", value: "german" },
  { label: "Greek", value: "greek" },
  { label: "Greenlandic (Kalaallisut)", value: "greenlandic" },
  { label: "Gujarati", value: "gujarati" },
  { label: "Guadeloupean Creole", value: "guadeloupean-creole" },
  { label: "Guarani (Bolivian)", value: "guarani-bolivian" },
  { label: "Guarani (Paraguayan)", value: "guarani" },
  { label: "Haitian Creole", value: "haitian-creole" },
  { label: "Haitian French", value: "haitian-french" },
  { label: "Hakka Chinese", value: "hakka-chinese" },
  { label: "Haryanvi", value: "haryanvi" },
  { label: "Hausa", value: "hausa" },
  { label: "Hawaiian", value: "hawaiian" },
  { label: "Herero", value: "herero" },
  { label: "Hiligaynon (Ilonggo)", value: "hiligaynon" },
  { label: "Hindi", value: "hindi" },
  { label: "Hmong", value: "hmong" },
  { label: "Ho", value: "ho" },
  { label: "Hopi", value: "hopi" },
  { label: "Hungarian", value: "hungarian" },
  { label: "Igbo", value: "igbo" },
  { label: "Ilocano", value: "ilocano" },
  { label: "Indonesian", value: "indonesian" },
  { label: "Inuktitut", value: "inuktitut" },
  { label: "Inuktitut (Eastern)", value: "inuktitut-eastern" },
  { label: "Inupiaq", value: "inupiaq" },
  { label: "Irish Gaelic", value: "irish" },
  { label: "Italian", value: "italian" },
  { label: "Japanese", value: "japanese" },
  { label: "Javanese", value: "javanese" },
  { label: "Kannada", value: "kannada" },
  { label: "Karachay‑Balkar", value: "karachay-balkar" },
  { label: "Kaqchikel", value: "kaqchikel" },
  { label: "Kabardian", value: "kabardian" },
  { label: "Kabyle", value: "kabyle" },
  { label: "Kala Lagaw Ya", value: "kala-lagaw-ya" },
  { label: "Kashmiri", value: "kashmiri" },
  { label: "Kazakh", value: "kazakh" },
  { label: "Khalkha Mongolian", value: "khalkha-mongolian" },
  { label: "Khasi", value: "khasi" },
  { label: "Khmer", value: "khmer" },
  { label: "K’iche’", value: "kiche" },
  { label: "Kikuyu", value: "kikuyu" },
  { label: "Kinyarwanda", value: "kinyarwanda" },
  { label: "Kirundi", value: "kirundi" },
  { label: "Kongo", value: "kongo" },
  { label: "Korean", value: "korean" },
  { label: "Kurdish (Kurmanji/Sorani)", value: "kurdish" },
  { label: "Ladakhi", value: "ladakhi" },
  { label: "Lao", value: "lao" },
  { label: "Latvian", value: "latvian" },
  { label: "Lakota", value: "lakota" },
  { label: "Lepcha", value: "lepcha" },
  { label: "Lingala", value: "lingala" },
  { label: "Lisu", value: "lisu" },
  { label: "Lithuanian", value: "lithuanian" },
  { label: "Lombard", value: "lombard" },
  { label: "Luxembourgish", value: "luxembourgish" },
  { label: "Luo", value: "luo" },
  { label: "Maithili", value: "maithili" },
  { label: "Makassarese", value: "makassarese" },
  { label: "Malay (Malaysia)", value: "malay" },
  { label: "Malayalam", value: "malayalam" },
  { label: "Malagasy", value: "malagasy" },
  { label: "Maltese", value: "maltese" },
  { label: "Mandarin Chinese", value: "mandarin-chinese" },
  { label: "Marathi", value: "marathi" },
  { label: "Marwari", value: "marwari" },
  { label: "Marshallese", value: "marshallese" },
  { label: "Martinican Creole", value: "martinican-creole" },
  { label: "Māori (Cook Islands)", value: "cook-islands-maori" },
  { label: "Maori", value: "maori" },
  { label: "Mapudungun", value: "mapudungun" },
  { label: "Marwari", value: "marwari" },
  { label: "Meitei (Manipuri)", value: "meitei" },
  { label: "Maya (Yucatec)", value: "yucatec-maya" },
  { label: "Minangkabau", value: "minangkabau" },
  { label: "Mixtec (Guerrero)", value: "mixtec" },
  { label: "Mizo (Lushai)", value: "mizo" },
  { label: "Mohawk", value: "mohawk" },
  { label: "Mongolian", value: "mongolian" },
  { label: "Mundari", value: "mundari" },
  { label: "Náhuatl (Central)", value: "nahuatl" },
  { label: "Nama/Damara", value: "nama" },
  { label: "Navajo", value: "navajo" },
  { label: "Nepali", value: "nepali" },
  { label: "Nenets", value: "nenets" },
  { label: "Niuean", value: "niuean" },
  { label: "Nigerian Pidgin", value: "nigerian-pidgin" },
  { label: "Norwegian", value: "norwegian" },
  { label: "Odia (Oriya)", value: "odia" },
  { label: "Ojibwe", value: "ojibwe" },
  { label: "Ossetian", value: "ossetian" },
  { label: "Papuan Malay", value: "papuan-malay" },
  { label: "Pampangan (Kapampangan)", value: "kapampangan" },
  { label: "Pashto", value: "pashto" },
  { label: "Persian (Farsi/Dari)", value: "persian" },
  { label: "Pitjantjatjara", value: "pitjantjatjara" },
  { label: "Polish", value: "polish" },
  { label: "Pohnpeian", value: "pohnpeian" },
  { label: "Portuguese", value: "portuguese" },
  { label: "Quechua", value: "quechua" },
  { label: "Quechua (Ayacucho)", value: "quechua-ayacucho" },
  { label: "Quechua (Cusco)", value: "quechua-cusco" },
  { label: "Rapa Nui", value: "rapa-nui" },
  { label: "Rapa Nui (Easter Island)", value: "rapa-nui-easter" },
  { label: "Romanian", value: "romanian" },
  { label: "Russian", value: "russian" },
  { label: "Samoan", value: "samoan" },
  { label: "Samogitian", value: "samogitian" },
  { label: "Sango", value: "sango" },
  { label: "Santali", value: "santali" },
  { label: "Saraiki", value: "saraiki" },
  { label: "Sardinian", value: "sardinian" },
  { label: "Sasak", value: "sasak" },
  { label: "Scottish Gaelic", value: "scottish-gaelic" },
  { label: "Serbo‑Croatian", value: "serbo-croatian" },
  { label: "Sesotho (Southern Sotho)", value: "sesotho" },
  { label: "Shona", value: "shona" },
  { label: "Sindhi", value: "sindhi" },
  { label: "Sinhalese", value: "sinhalese" },
  { label: "Slovak", value: "slovak" },
  { label: "Somali", value: "somali" },
  { label: "Spanish", value: "spanish" },
  { label: "Sranan Tongo", value: "sranan-tongo" },
  { label: "Sundanese", value: "sundanese" },
  { label: "Swahili", value: "swahili" },
  { label: "Swedish", value: "swedish" },
  { label: "Sylheti", value: "sylheti" },
  { label: "Tagalog (Filipino)", value: "tagalog" },
  { label: "Tajik", value: "tajik" },
  { label: "Tamil", value: "tamil" },
  { label: "Tamasheq (Tuareg)", value: "tamazight" },
  { label: "Tatar", value: "tatar" },
  { label: "Telugu", value: "telugu" },
  { label: "Tetum", value: "tetum" },
  { label: "Tetum‑Prasa", value: "tetum-prasa" },
  { label: "Thai", value: "thai" },
  { label: "Tigrinya", value: "tigrinya" },
  { label: "Tlingit", value: "tlingit" },
  { label: "Tok Pisin", value: "tok-pisin" },
  { label: "Tokelauan", value: "tokelauan" },
  { label: "Tongan", value: "tongan" },
  { label: "Toraja", value: "toraja" },
  { label: "Torres Strait Creole", value: "torres-strait-creole" },
  { label: "Turkish", value: "turkish" },
  { label: "Tswana", value: "tswana" },
  { label: "Ukrainian", value: "ukrainian" },
  { label: "Urdu", value: "urdu" },
  { label: "Uzbek", value: "uzbek" },
  { label: "Uyghur", value: "uyghur" },
  { label: "Vietnamese", value: "vietnamese" },
  { label: "Walmajarri", value: "walmajarri" },
  { label: "War‑Jaintia", value: "war-jaintia" },
  { label: "Waray", value: "waray" },
  { label: "Warlpiri", value: "warlpiri" },
  { label: "Wolof", value: "wolof" },
  { label: "Xhosa", value: "xhosa" },
  { label: "Yakut (Sakha)", value: "yakut" },
  { label: "Yolŋu Matha", value: "yolngu" },
  { label: "Yoruba", value: "yoruba" },
  { label: "Zamboangueño Chavacano", value: "chavacano" },
  { label: "Zapotec (Oaxaca Central)", value: "zapotec" },
  { label: "Zhuang", value: "zhuang" },
  { label: "Zigula/Shirazi (Swahili coast)", value: "zigula" },
  { label: "Zulu", value: "zulu" },
];

//  Admin Admission ------------- configs
export const YES_NO_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
export const PRIMARY_CONTACT_OPTIONS = [
  { label: "Father", value: "father" },
  { label: "Mother", value: "mother" },
  { label: "Guardian", value: "guardian" },
];

export const ENROLLMENT_STATUS_OPTIONS = [
  { label: "Full Time", value: "Full Time" },
  { label: "Part Time", value: "Part Time" },
];
